import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { announcement } from '../../data/events';
export function AnnouncementBar() {
  return <div className="w-full bg-brand-navy text-white" data-id="element-268" data-mp="1j3fv0tlqn31a">
      <div className="mx-auto flex w-full max-w-6xl flex-col items-start gap-1 px-5 py-2 sm:flex-row sm:items-center sm:justify-center sm:gap-4 sm:px-8" data-id="element-269" data-mp="1j3pjgcr4x24v">
        <p className="font-meta text-[12px] leading-snug sm:text-[13px]" data-id="element-270" data-mp="rci2bpjdfift">
          {announcement.message}
        </p>
        <Link to={announcement.linkTo} className="inline-flex shrink-0 items-center gap-1 font-meta text-[12px] font-semibold text-brand-yellow underline underline-offset-4 hover:no-underline sm:text-[13px]" data-id="element-271" data-mp="vemsufeivyy8">
          {announcement.linkLabel}
          <ArrowRightIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-272" data-mp="2bsd0fw4up5cm" />
        </Link>
      </div>
    </div>;
}